export const headerT ={
  hamburger: '0.75s',
}